"use strict";
exports.__esModule = true;
exports.SvgIcon = exports.EIcon = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importDefault(require("react"));
function Icon(props) {
    var name = props.name, fontSize = props.fontSize, customColor = props.customColor, style = props.style, rest = tslib_1.__rest(props, ["name", "fontSize", "customColor", "style"]);
    return (react_1["default"].createElement(core_1.Icon, tslib_1.__assign({}, rest, { fontSize: fontSize, style: tslib_1.__assign(tslib_1.__assign({}, style), { color: customColor }) }), name));
}
exports["default"] = Icon;
function EIcon(props) {
    var name = props.name, color = props.color, _a = props.fontSize, fontSize = _a === void 0 ? 'default' : _a, htmlColor = props.htmlColor, style = props.style, rest = tslib_1.__rest(props, ["name", "color", "fontSize", "htmlColor", "style"]);
    var theme = core_1.useTheme();
    var colorCss = getColor(theme, color, htmlColor);
    var sizeCss = getSize(fontSize);
    var componentStyle = tslib_1.__assign(tslib_1.__assign({}, style), { display: 'inline-flex', fontSize: sizeCss, color: colorCss });
    return (react_1["default"].createElement("i", tslib_1.__assign({ className: "epilot-icon epilot-icon-" + name + "  notranslate", style: componentStyle }, rest)));
}
exports.EIcon = EIcon;
function getSize(fontSize) {
    if (fontSize) {
        switch (fontSize) {
            case 'inherit':
                return '';
            case 'large':
                return 32;
            case 'small':
                return 20;
            case 'default':
                return 24;
            default:
                return fontSize;
        }
    }
    return 24;
}
function getColor(theme, color, htmlcolor) {
    switch (color) {
        case 'primary':
            return theme.palette.primary.main;
        case 'secondary':
            return theme.palette.secondary.main;
        case 'action':
            return theme.palette.success.main;
        case 'disabled':
            return theme.palette.action.disabled;
        case 'error':
            return theme.palette.error.main;
        default:
            return htmlcolor;
    }
}
function SvgIcon(props) {
    return react_1["default"].createElement(core_1.SvgIcon, tslib_1.__assign({}, props));
}
exports.SvgIcon = SvgIcon;
//# sourceMappingURL=Icon.js.map